import { render, staticRenderFns } from "./GeneralLogsTab.vue?vue&type=template&id=2f5b5e32&scoped=true"
import script from "./GeneralLogsTab.vue?vue&type=script&lang=js"
export * from "./GeneralLogsTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralLogsTab.vue?vue&type=style&index=0&id=2f5b5e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b5e32",
  null
  
)

export default component.exports